/**
 * KWC · Intelligent navigation prefetch
 * ---------------------------------------------------------------------------
 * Makes clicking a product / collection / menu link feel near-instant by
 * downloading the destination HTML on hover or tap-intent, so the click lands
 * with no network wait. Uses the native Speculation Rules API (prefetch, not
 * prerender — safe with the Meta pixel and Shopify analytics, which stay on the
 * real navigation) with a hover-prefetch <link> fallback for other browsers.
 *
 * Deliberately conservative:
 *   - Skips entirely on data-saver or slow (2g/slow-2g) connections.
 *   - "moderate" eagerness = prefetch on hover / pointer-down, not on sight, so
 *     it never mass-downloads every link.
 *   - Excludes cart, checkout, account and anything marked [data-no-prefetch].
 *
 * Dependency-free, deferred, non-blocking.
 */
(function () {
  var conn = navigator.connection;
  if (conn && (conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || ''))) {
    return; // respect data-saver / slow networks
  }

  var supportsRules =
    HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');

  if (supportsRules) {
    var rules = {
      prefetch: [
        {
          where: {
            and: [
              { href_matches: '/*' },
              { not: { href_matches: '/cart*' } },
              { not: { href_matches: '/checkout*' } },
              { not: { href_matches: '/account*' } },
              { not: { href_matches: '/*\\?*' } }, // skip query-string URLs (filters, variants)
              { not: { selector_matches: '[data-no-prefetch]' } },
              { not: { selector_matches: '[href^="mailto:"]' } },
              { not: { selector_matches: '[href^="tel:"]' } },
            ],
          },
          eagerness: 'moderate',
        },
      ],
    };
    var s = document.createElement('script');
    s.type = 'speculationrules';
    s.textContent = JSON.stringify(rules);
    document.head.appendChild(s);
    return;
  }

  /* --- Fallback: hover / touch-intent <link rel="prefetch"> --------------- */
  var prefetched = Object.create(null);
  function shouldSkip(href) {
    return (
      !href ||
      prefetched[href] ||
      href.indexOf('#') === 0 ||
      /\/(cart|checkout|account)(\/|$|\?)/.test(href) ||
      href.indexOf('?') !== -1 ||
      href.indexOf('mailto:') === 0 ||
      href.indexOf('tel:') === 0
    );
  }
  function prefetch(href) {
    if (shouldSkip(href)) return;
    prefetched[href] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    l.as = 'document';
    document.head.appendChild(l);
  }
  function onIntent(e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.hostname !== location.hostname || a.hasAttribute('data-no-prefetch')) return;
    prefetch(a.href);
  }
  document.addEventListener('pointerover', onIntent, { capture: true, passive: true });
  document.addEventListener('touchstart', onIntent, { capture: true, passive: true });
})();
